import styled from 'styled-components';
import { Form } from '@unform/web';

export const Wrapper = styled(Form)`
  > div:not(:first-child),
  > fieldset {
    margin-top: 2rem;
  }

  > button {
    margin: 2rem 0;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`
